const chatReducer = (state, action) => {
    if (state === undefined) {
        state = {
            history: [],
            error: null
        };
        return state;
    }
    switch (action.type) {
        case "SET_CHAT_HISTORY":
            return {
                ...state,
                history: action.history
            };
        case "ADD_CHAT_MESSAGE":
            return {
                ...state,
                history: [
                    ...state.history,
                    {
                        role: action.role,
                        content: action.content
                    }
                ]
            };
        case "REMOVE_LAST_CHAT_MESSAGE":
            return {
                ...state,
                history: state.history.slice(0, -1)
            };
        case "ADD_CHAT_ERROR":
            return {
                ...state,
                //history: state.history.slice(0, -1), // do REMOVE_LAST_CHAT_MESSAGE,
                error: action.error
            };
        case "CLEAR_CHAT_ERROR":
            return {
                ...state,
                error: null
            };
        default:
            return state
    }
};
export default chatReducer;
